import { render, staticRenderFns } from "./icare_join.vue?vue&type=template&id=fb23e9da&"
import script from "./icare_join.vue?vue&type=script&lang=js&"
export * from "./icare_join.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports